import { useHomeQuery } from '@/queries/home.query';
import { AnimatePresence, motion } from 'framer-motion';
import { BadgeCheck, Headset, ShieldCheck, Users } from 'lucide-react';
import { useState } from 'react';
import { Body, BodySm, H2, H5 } from './ui/typography/Typography';

export default function WhyChooseUs() {
  const [activeIndex, setActiveIndex] = useState(null);
  const { isLoading } = useHomeQuery();
  const benefits = [
    {
      title: 'Berbasis Prinsip Syariah',
      desc: 'KSPPS Abdi Kerta Raharja menjalankan seluruh operasionalnya berdasarkan prinsip syariah, sehingga setiap transaksi terbebas dari riba, gharar (ketidakjelasan), dan maysir (spekulasi). Kami berkomitmen untuk memberikan layanan keuangan yang halal dan berkah bagi seluruh anggota.',
      icon: <ShieldCheck className="w-5 h-5 text-primary-600" />,
    },
    {
      title: 'Perlindungan Aman & Terpercaya',
      desc: 'Sebagai koperasi yang telah berpengalaman, KSPPS Abdi Kerta Raharja memiliki legalitas resmi dan diawasi oleh otoritas yang berwenang. Kepercayaan anggota adalah prioritas utama kami dalam menjalankan sistem keuangan yang aman, transparan, dan profesional.',
      icon: <ShieldCheck className="w-5 h-5 text-primary-600" />,
    },
    {
      title: 'Kemudahan Akses & Pelayanan',
      desc: 'Kami menyadari bahwa setiap anggota memiliki kebutuhan finansial yang berbeda. Untuk itu, KSPPS Abdi Kerta Raharja menghadirkan beragam produk simpanan dan pembiayaan yang dirancang secara fleksibel, transparan, serta mudah diakses oleh seluruh lapisan masyarakat. Dengan layanan berbasis syariah, kami berkomitmen memberikan solusi keuangan yang adil, aman, dan penuh keberkahan.',
      icon: <Headset className="w-5 h-5 text-primary-600" />,
    },
    {
      title: 'Meningkatkan Kesejahteraan Bersama',
      desc: 'Sebagai koperasi berbasis kekeluargaan dan kebersamaan, KSPPS Abdi Kerta Raharja tidak hanya berfokus pada keuntungan, tetapi juga pada pemberdayaan ekonomi anggota dan komunitas. Kami hadir untuk mendukung setiap anggota agar dapat berkembang, mandiri, dan mencapai kesejahteraan yang lebih baik. Bersama KSPPS AKR, setiap langkah menuju kemandirian ekonomi menjadi lebih ringan, penuh arti, dan penuh keberkahan.',
      icon: <Users className="w-5 h-5 text-primary-600" />,
    },
    {
      title: 'Dukungan & Pendampingan Usaha',
      desc: 'Bagi anggota yang memiliki usaha atau ingin memulai bisnis, KSPPS Abdi Kerta Raharja memberikan pendampingan serta solusi keuangan yang tepat guna. Kami percaya bahwa dengan kerja sama dan dukungan yang berkelanjutan, setiap anggota dapat mencapai kesuksesan finansial.',
      icon: <BadgeCheck className="w-5 h-5 text-primary-600" />,
    },
  ];

  const toggleAccordion = (i) => {
    setActiveIndex(activeIndex === i ? null : i);
  };

  if (isLoading) return null;
  return (
    <div className="w-full lg:w-10/12 sm:pr-0 lg:pr-0 xl:pr-10">
      <div className="space-y-4">
        <H2 className=" text-gray-900">
          Mengapa Anggota <span className="text-primary-600"> Percaya</span> <br /> Kepada{' '}
          <span className="text-primary-600">Koperasi AKR Syariah?</span>
        </H2>
        <Body className="text-gray-800 leading-relaxed">
          Kami memberikan layanan yang terjamin, responsif, dan terpercaya untuk seluruh anggota.
          Dengan legalitas yang kuat dan pelayanan yang memprioritaskan kenyamanan serta keamanan
          Anda.
        </Body>
      </div>

      <div className="space-y-4 mt-10">
        {benefits.map((item, i) => (
          <div key={i} className="border rounded-xl bg-white shadow-sm">
            <button
              onClick={() => toggleAccordion(i)}
              className="w-full flex items-center justify-between p-5 text-left"
            >
              <div className="flex items-center gap-3">
                {item.icon}
                <H5 className="text-gray-800">{item.title}</H5>
              </div>
              <span className="text-primary-600">{activeIndex === i ? '-' : '+'}</span>
            </button>

            <AnimatePresence initial={false}>
              {activeIndex === i && (
                <motion.div
                  initial={{ height: 0, opacity: 0 }}
                  animate={{ height: 'auto', opacity: 1 }}
                  exit={{ height: 0, opacity: 0 }}
                  transition={{ duration: 0.3, ease: 'easeInOut' }}
                  className="overflow-hidden"
                >
                  <BodySm className="p-5 pt-0 text-gray-600">{item.desc}</BodySm>
                </motion.div>
              )}
            </AnimatePresence>
          </div>
        ))}
      </div>
    </div>
  );
}
